import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Button } from 'src/shared/components/ui/buttons/button'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

import HomeAffordCardMobileImage from './assets/home-afford-card-image-sm.png'
import HomeAffordCardImage from './assets/home-afford-card-image.png'

export default function HomeAffordCard() {
  const { width } = useWindowSize()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(paths.marketplace.instantMatch.mortgageCalculator.getHref())
  }

  if (width < 768) {
    return (
      <div
        className="group flex flex-col items-center justify-center gap-4 rounded-[25px] bg-primary p-[25px] hover:cursor-pointer"
        onClick={handleClick}
      >
        <div className="max-w-xs">
          <img src={HomeAffordCardMobileImage} alt="home" />
        </div>
        <div className="-mt-2 text-center text-[26px] font-bold leading-[135%] tracking-[-3%] text-white">
          How much can I afford?
        </div>
        <Button
          variant="default"
          size="lg"
          className="h-[50px] w-full max-w-[270px] rounded-full bg-white text-[15px] font-bold text-primary group-hover:bg-white/90 group-hover:font-bold"
        >
          Calculate
        </Button>
      </div>
    )
  }

  return (
    <div
      className="border-primary/10 group relative flex size-full h-full flex-col justify-between rounded-[25px] border bg-primary shadow-[2px_2px_10px_0px_rgba(25,58,45,0.10)] transition-shadow duration-100 hover:cursor-pointer hover:shadow-[2px_2px_10px_0px_rgba(25,58,45,0.20)]"
      onClick={handleClick}
    >
      <div>
        <div className="flex w-full flex-col items-center justify-center gap-4 overflow-hidden rounded-[25px] pt-10 text-white">
          <div className="max-w-[200px] rounded-[20px]">
            <img src={HomeAffordCardImage} alt="home" />
          </div>
          {/* min width 284px added to prevent text from wrapping to 3 lines */}
          <div className="min-w-[284px] p-5 text-center text-[30px] font-bold leading-[135%] tracking-[-3%] text-white">
            How much can I afford?
          </div>
        </div>
      </div>
      <div className="p-5 pt-0">
        <Button
          variant="default"
          size="lg"
          className="h-[50px] w-full rounded-full bg-white text-[15px] text-primary group-hover:bg-white/90 group-hover:font-bold"
        >
          Calculate
        </Button>
      </div>
    </div>
  )
}
